<template>
  <div>
    <div>
      <XIcon
        name="fa/regular/times"
        class="absolute pin-t pin-r leading-none m-4 cursor-pointer text-lg text-grey-40 hover:text-black"
        @click="close" />
      <div class="text-xl font-medium text-center border-b border-grey-90 py-2">
        {{ $t('event.timeline.socials.share') }}
      </div>
    </div>

    <div class="px-6 py-4">
      <template v-for="channel in shareChannels">
        <XSocialShare
          v-if="channel !== 'download'"
          :key="channel"
          :channel="channel"
          :url="showUrl"
          :message="shareMessage"
          :hashtags="shareHashtags"
          :description="shareDescription"
          v-analytics:click="{
            category: 'share',
            name: channel,
            reactionId: reactionId
          }"
          class="relative block text-lg text-grey-60 py-2 font-normal no-underline hover:text-grey-40 transition transition-text">
          <XIcon
            :name="iconNameByChannel(channel)"
            class="absolute pin-l text-xl leading-tight" />
          <span class="pl-8">{{ $t('event.timeline.socials.' + channel) }}</span>
        </XSocialShare>
      </template>
    </div>
  </div>
</template>

<script>
import XSocialShare from '@plat/components/SocialShare'

export default {
  components: { XSocialShare },

  props: {
    reactionId: {
      type: String
    },
    showUrl: {
      type: String
    },
    shareChannels: {
      type: Array
    },
    shareMessage: {
      type: String
    },
    shareHashtags: {
      type: Array
    },
    shareDescription: {
      type: String
    }
  },

  created () {
    document.body.style.overflow = 'hidden'
  },

  beforeDestroy () {
    document.body.style.overflow = 'auto'
  },

  methods: {
    iconNameByChannel (channel) {
      switch (channel) {
        case 'email':
          return 'fa/solid/envelope'
        case 'linkedIn':
          return 'fa/brands/linkedin'
        default:
          return 'fa/brands/' + channel
      }
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" module>
.modal-content {
  overflow-y: auto;
  height: auto;
  max-height: calc(100vh - 160px);
}

.modal-body {
  min-height: calc(100% - 110px);
}
</style>
